import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { api, TIPOS_CITA } from "@/lib/api";
import { fechaLarga } from "@/components/ProximasCitas";

export default function CitasFamiliaImprimir() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/patients/${id}/proximas-citas`).then((r) => setD(r.data));
  }, [id]);
  if (!d) return <p className="p-8 text-sm text-slate-500">Cargando…</p>;
  return (
    <div className="mx-auto max-w-2xl bg-white p-8 print:p-0" data-testid="citas-familia-imprimir">
      <button type="button" onClick={() => window.print()} data-testid="citas-familia-print" className="mb-5 inline-flex items-center gap-2 rounded-md bg-[#1E3A8A] px-4 py-2 text-sm font-medium text-white hover:bg-[#1E40AF] print:hidden"><Printer className="h-4 w-4" />Imprimir</button>
      <p className="text-sm font-semibold text-slate-500">Salud y Visión</p>
      <h1 className="mb-1 text-xl font-bold">Próximas citas de {d.patient.nombre}</h1>
      <p className="mb-5 text-xs text-slate-500">{d.patient.codigo ? `Ficha nº ${d.patient.codigo}` : ""}</p>
      {d.citas.length ? (
        <table className="w-full text-sm">
          <tbody>
            {d.citas.map((c) => (
              <tr key={c.id} className="border-b border-slate-200">
                <td className="py-2 font-medium first-letter:uppercase">{fechaLarga(c.fecha)}</td>
                <td className="py-2 font-semibold">{c.inicio}</td>
                <td className="py-2">{TIPOS_CITA[c.tipo]?.label}</td>
                <td className="py-2 text-slate-600">{c.profesional}{c.centro ? ` · ${c.centro === "MADRID" ? "Madrid" : "Alcobendas"}` : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : <p className="text-sm text-slate-500">No tiene citas próximas.</p>}
      <p className="mt-6 text-xs text-slate-500">Si no podéis venir a alguna cita, avisadnos con antelación. Gracias.</p>
    </div>
  );
}
